import React, { useEffect, useState } from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { CreateTeacherDialog } from "../components/CreateTeacherDialog";
import { useApiClient } from "../../../api";
import { FruitifyTeacherSearch } from "../components/FruitifyTeacherSearch";

const TeachersOverview = () => {
  const [open, setOpen] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [schools, setSchools] = useState([]);
  const ApiClient = useApiClient();

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const response = await ApiClient.schools.getTeachers();
        if (response) {
          setSchools(response.schools);
          setTeachers(response.teachers);
        }
      } catch (error) {
        console.error("Failed to fetch schools", error);
      }
    };
    fetchTeachers();
  }, []);

  return (
    <FruitifyContainer>
      <CreateTeacherDialog open={open} setOpen={setOpen} schools={schools} />
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        gap={2}
        mb={2}
      >
        <Typography variant="h3" fontWeight="bold">
          Teachers
        </Typography>
        <Button
          variant="contained"
          endIcon={<Add />}
          onClick={() => setOpen(true)}
        >
          Add teacher
        </Button>
      </Box>
      <FruitifyTeacherSearch teachers={teachers} />
    </FruitifyContainer>
  );
};

export default TeachersOverview;
